import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { CheckCircle, XCircle } from 'lucide-react';
export function QualificationSection() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <section className="relative py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-stone-950" data-id="element-4513">
      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 30
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-5xl mx-auto" data-id="element-4514">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-center text-stone-100 mb-12 sm:mb-16" style={{
        fontFamily: 'Cinzel, serif'
      }} data-id="element-4515">
          Is This Right For You?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12" data-id="element-4516">
          {/* Who this is for */}
          <div data-id="element-4517">
            <h3 className="text-xl sm:text-2xl font-bold text-green-400 mb-6 flex items-center gap-3" data-id="element-4518">
              <CheckCircle className="w-6 h-6 sm:w-8 sm:h-8" data-id="element-4519" />
              This IS For You If:
            </h3>
            <ul className="space-y-4 sm:space-y-6" data-id="element-4520">
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-4521">
                <div className="w-1.5 h-1.5 bg-green-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-4522" />
                <span data-id="element-4523">
                  You are a medical professional, coach, or serious biohacker
                  who wants to operate at the cutting edge.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-4524">
                <div className="w-1.5 h-1.5 bg-green-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-4525" />
                <span data-id="element-4526">
                  You understand that true mastery requires deep study and
                  ongoing education.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-4527">
                <div className="w-1.5 h-1.5 bg-green-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-4528" />
                <span data-id="element-4529">
                  You want to be able to solve complex health puzzles that leave
                  others stumped.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-4530">
                <div className="w-1.5 h-1.5 bg-green-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-4531" />
                <span data-id="element-4532">
                  You value scientific validation and evidence-based protocols
                  over hype.
                </span>
              </li>
            </ul>
          </div>

          {/* Who this is NOT for */}
          <div data-id="element-4533">
            <h3 className="text-xl sm:text-2xl font-bold text-red-400 mb-6 flex items-center gap-3" data-id="element-4534">
              <XCircle className="w-6 h-6 sm:w-8 sm:h-8" data-id="element-4535" />
              This Is NOT For You If:
            </h3>
            <ul className="space-y-4 sm:space-y-6" data-id="element-4536">
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-4537">
                <div className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-4538" />
                <span data-id="element-4539">
                  You are looking for a "magic pill" that requires no effort or
                  understanding.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-4540">
                <div className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-4541" />
                <span data-id="element-4542">
                  You are not willing to invest time in learning the
                  foundational principles.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-4543">
                <div className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-4544" />
                <span data-id="element-4545">
                  You are satisfied with mainstream, surface-level health
                  advice.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-4546">
                <div className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-4547" />
                <span data-id="element-4548">
                  You want quick hacks rather than deep, sustainable biological
                  optimization.
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center mt-10 sm:mt-14" data-id="element-4549">
          <p className="text-stone-400 text-base sm:text-lg mb-4 italic" data-id="element-4550">
            If the left column sounds like you...
          </p>
          <button onClick={() => {
          const pricingSection = document.querySelector('[data-pricing-section]');
          if (pricingSection) {
            pricingSection.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }} className="inline-block px-8 sm:px-12 py-4 sm:py-5 bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-500 hover:to-amber-400 text-black font-bold text-lg sm:text-xl rounded-lg shadow-[0_0_30px_rgba(217,119,6,0.4)] hover:shadow-[0_0_50px_rgba(217,119,6,0.6)] hover:scale-105 transition-all duration-300 min-h-[44px]" data-id="element-4551">
            Join the Private Research Order Now
          </button>
        </div>
      </motion.div>
    </section>;
}